import { useAppLanguage } from '@/hooks/useAppLanguage';
import Colors from '@/constants/colors';
import DetailPageLayout from '@/components/DetailPageLayout';
import DetailPageHeader from '@/components/DetailPageHeader';

export default function ChangelogPage() {
  const { language } = useAppLanguage();

  const title = language === 'ru' ? 'История изменений' : language === 'pl' ? 'Historia zmian' : 'Changelog';
  const content = language === 'ru'
    ? 'История изменений приложения. Здесь вы можете увидеть все обновления и улучшения в каждой версии.'
    : language === 'pl'
    ? 'Historia zmian aplikacji. Tutaj możesz zobaczyć wszystkie aktualizacje i ulepszenia w każdej wersji.'
    : 'Changelog of the application. Here you can see all updates and improvements in each version.';

  return (
    <DetailPageLayout>
      <DetailPageHeader title={title} />
      <div style={styles.content}>
        <p style={styles.bodyText}>{content}</p>
      </div>
    </DetailPageLayout>
  );
}

const styles = {
  content: {
    backgroundColor: Colors.background,
    minHeight: '100vh',
  } as React.CSSProperties,

  bodyText: {
    fontSize: '16px',
    color: Colors.text,
    lineHeight: '24px',
    padding: '24px',
    margin: 0,
  } as React.CSSProperties,
};
